import './compact-tooltip-ui.js';
import naja from 'naja';
import 'flowbite';

// Croppie importujeme a dáváme do window, kdyby ho někdo potřeboval globálně
import Croppie from 'croppie';
window.Croppie = Croppie;

// Naju dáme do window (pro Tracy bar a ladění)
window.naja = naja;

import { initAllPageComponents } from './page-ui.js';
import { initFeedUI } from './feed-ui.js';
import { initProfileUI } from './profile-ui.js';
import { initMatchCenter } from './match-center.js';
import { initPredictionV2 } from './prediction-v2.js';
import { configureNaja } from './naja-setup.js';
import { initMailEditors } from './mail-editor.js';

// 1. Nakonfigurujeme Naju (přidáme listenery)
configureNaja(naja);

// 2. Spustíme aplikaci, až bude DOM připraven
document.addEventListener('DOMContentLoaded', () => {
    console.log('🚀 Aplikace startuje...');

    naja.initialize();                // 1. Start Naji
    initAllPageComponents(document);   // 2. Globální UI
    initFeedUI(document);              // 3. Feed UI
    initProfileUI(document);           // 4. Profil UI
    initMatchCenter(naja, document);     // 5. Studio
    initPredictionV2(document);           // 6. La Clasiga V2 LAB
    initMailEditors(document);             // 7. Admin mailing editor

    console.log('🏁 Aplikace připravena.');
});